import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { getUserGroups } from '../shared/utils/auth-groups.util';

/**
 * Page d'un utilisateur connecté à qui aucun espace n'est ouvert.
 *
 * Elle est le pendant d'`/onboarding` pour un cas voisin mais distinct : là où
 * l'onboarding s'adresse à un compte qui n'a **aucun** groupe (rien n'est
 * configuré), celle-ci s'adresse à un compte actif qui porte le rôle de base
 * `GLUSER` sans habilitation d'espace — et à quiconque atteint une zone
 * réservée, `AdminGuard` y renvoyant aussi.
 *
 * Aucun appel de données : par construction, cet utilisateur n'y a pas droit.
 * Seuls son adresse e-mail et ses groupes sont affichés, pour que
 * l'administrateur sache de quel compte on lui parle.
 */
@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [],
  templateUrl: './no-access.component.html'
})
export class NoAccessComponent implements OnInit {
  readonly email = signal('');
  readonly groups = signal<string[]>([]);

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.authService.getUserData().subscribe({
      next: data => this.email.set(data?.email ?? ''),
      error: () => this.email.set('')
    });
    this.groups.set(await getUserGroups());
  }

  async signOut(): Promise<void> {
    try {
      await this.authService.logout();
      this.router.navigate(['/login']);
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  }
}
